import type { Season } from '@interfaces/seasons.interface';

/**
 * Builds one `Season` in the canonical (global, host-level) model, with sane defaults for every
 * field so a test only has to override what it cares about.
 */
export function buildSeason(overrides?: Partial<Season>): Season {
  return {
    id: 'season-low',
    name: 'Temporada baja',
    colour: '#838b9c',
    priority: 3,
    ranges: [{ from: '2026-01-01', to: '2026-03-31' }],
    rule: { type: 'FIXED', value: 95 },
    assignment: { allRentals: true, rentalIds: [] },
    version: 1,
    ...overrides,
  };
}

/**
 * Seeds the host season list with the three seasons a host can have, in their design colours. They
 * still cover the shapes the panels need: a season with several ranges, one priced with a `PERCENT`
 * rule, and one that reaches only some rentals.
 */
export function buildSeasons(): Season[] {
  return [
    buildSeason(),
    buildSeason({
      id: 'season-mid',
      name: 'Temporada media',
      colour: '#394661',
      priority: 2,
      ranges: [{ from: '2026-04-01', to: '2026-06-30' }],
      rule: { type: 'FIXED', value: 120 },
      assignment: { allRentals: true, rentalIds: [] },
    }),
    buildSeason({
      id: 'season-high',
      name: 'Temporada alta',
      colour: '#08183a',
      priority: 1,
      ranges: [
        { from: '2026-07-01', to: '2026-08-31' },
        { from: '2026-10-10', to: '2026-10-12' },
        { from: '2026-12-20', to: '2027-01-07' },
      ],
      rule: { type: 'PERCENT', value: 140 },
      assignment: { allRentals: false, rentalIds: ['rental-mojacar-001', 'rental-mojacar-002'] },
    }),
  ];
}
